import React, { useState } from "react";
import "./DeviceCompatibilityChecker.css";

function DeviceCompatibilityChecker({ appName = "this APK" }) {
  const [device, setDevice] = useState("");
  const value = device.toLowerCase();

  const iphone = /iphone|ipad|ios|apple/.test(value);
  const samsung = /samsung|galaxy/.test(value);
  const vivo = /vivo|iqoo/.test(value);
  const oppo = /oppo/.test(value);
  const realme = /realme/.test(value);
  const redmi = /redmi|xiaomi|mi |poco/.test(value);
  const oneplus = /oneplus/.test(value);
  const motorola = /moto|motorola/.test(value);
  const infinixTecno = /infinix|tecno/.test(value);
  const android = /android/.test(value);

  const lowEnd = /y20|y21|y15|a10|a12|a03|a04|c11|c21|c25|hot|spark|go/.test(value);
  const midRange = /note|a14|a15|a24|a34|a35|y27|y28|f21|f23|narzo|m14|m15/.test(value);
  const flagship = /ultra|pro max|s23|s24|s25|fold|flip|oneplus 11|oneplus 12|gt/.test(value);

  const getResult = () => {
    if (!device.trim()) return null;

    if (iphone) {
      return {
        type: "danger",
        title: "iPhone / iOS Not Supported",
        text: "APK files cannot be installed on iPhone, iPad, or iOS. Use the Apple App Store instead."
      };
    }

    if (flagship) {
      return {
        type: "success",
        title: "Excellent Compatibility",
        text: `${device} looks like a high-performance device. ${appName} should run smoothly if the APK supports your Android version.`
      };
    }

    if (lowEnd) {
      return {
        type: "warning",
        title: "Likely Works, But Check Storage",
        text: `${device} looks like a budget Android phone. ${appName} may work, but keep free storage and close background apps before installing.`
      };
    }

    if (midRange) {
      return {
        type: "success",
        title: "Good Compatibility",
        text: `${device} looks like a mid-range Android phone. ${appName} should work well for normal usage.`
      };
    }

    if (samsung) {
      return {
        type: "success",
        title: "Samsung Galaxy Supported",
        text: `${appName} should work on most Samsung Galaxy Android phones. Allow unknown app installation if Android asks.`
      };
    }

    if (vivo) {
      return {
        type: "success",
        title: "Vivo / iQOO Supported",
        text: `${appName} should work on most Vivo and iQOO Android phones. Check storage and Android version first.`
      };
    }

    if (oppo) {
      return {
        type: "success",
        title: "OPPO Supported",
        text: `${appName} should work on most OPPO Android phones. You may need to allow browser/file manager install permission.`
      };
    }

    if (realme) {
      return {
        type: "success",
        title: "Realme Supported",
        text: `${appName} should install on most Realme phones running Android. Check app permissions after install.`
      };
    }

    if (redmi) {
      return {
        type: "success",
        title: "Redmi / Xiaomi / POCO Supported",
        text: `${appName} should work on most MIUI/HyperOS Android phones. Enable install from unknown sources if needed.`
      };
    }

    if (oneplus) {
      return {
        type: "success",
        title: "OnePlus Supported",
        text: `${appName} should work smoothly on most OnePlus Android devices.`
      };
    }

    if (motorola) {
      return {
        type: "success",
        title: "Motorola Supported",
        text: `${appName} should work on most Motorola Android phones with enough storage.`
      };
    }

    if (infinixTecno) {
      return {
        type: "warning",
        title: "Likely Compatible",
        text: `${appName} may work on ${device}. For best results, keep storage free and use a recent Android version.`
      };
    }

    if (android) {
      return {
        type: "success",
        title: "Android Device Detected",
        text: `${appName} can install on Android devices if version, storage, and permissions are supported.`
      };
    }

    return {
      type: "warning",
      title: "Device Not Clearly Detected",
      text: "If your phone runs Android, APK files may work. If it is iPhone/iOS, APK files will not install."
    };
  };

  const result = getResult();

  return (
    <div className="device-checker-mini">
      <h3>Check Device</h3>

      <input
        value={device}
        onChange={(e) => setDevice(e.target.value)}
        placeholder="Vivo Y20, Redmi Note 12..."
      />

      {result && (
        <div className={`device-mini-result ${result.type}`}>
          <strong>{result.title}</strong>
          <p>{result.text}</p>
        </div>
      )}
    </div>
  );
}

export default DeviceCompatibilityChecker;